<template>
    <modal @close="closeModal" dialog="modal-sm" class="dark-top">
        <div slot="title">
            <h2>Send Invoice</h2>
        </div>
        <div slot="body">
            <div>
                <div class="d-flex flex-column p-4 fs-large" v-if="getSelectedInvoice.invoiceClientEmail">
                    <span class="mb-4">{{ sendInvoiceMessage }}</span>
                    <input type="text"
                           :value="getSelectedInvoice.invoiceClientEmail"
                           disabled  
                           class="bold input-heigth">
                    </input>
                </div>
                <!-- TODO: Validar questão dos nomes em função do que vem no invoice. Atenção quando invoice sem ser da reserva mas sim menu -->
                <div class="p-4" v-else>
                    <span class="fs-normal">
                        There is no email associated. Please check the <strong>{{getSelectedInvoice.targetType === 0 ? 'Customer' : 'Agent'}}</strong> information.
                    </span>
                </div>
            </div>
        </div>

        <div slot="footer">
            <div class="d-flex justify-content-end pr1">
                <button type="button" class="btn cancel wider mr-3" @click="closeModal">Cancel</button>
                <button type="button" class="btn ok wider" :class="{'disabled notAllowed': !getSelectedInvoice.invoiceClientEmail}" :disabled="!getSelectedInvoice.invoiceClientEmail" @click="sendEmail">
                    <span>Send Email</span>
                </button>
            </div>
        </div>
    </modal>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import Modal from './Modal';

    export default {
        data: function() {
            return {
                sendInvoiceMessage: 'The invoice will be sent to the following email address:'
            }
        },
        computed: {
            ...mapGetters([
                'getSelectedInvoice',
                'getSelectedReservation'
            ])
        },
        methods: {
            ...mapActions([
                'closeModal',
            ]),
            sendEmail: function() {
                this.eventHub.$emit('closeSendInvoiceToMail');
                this.closeModal();
            },
            closeWindow: function() {
                this.closeModal();
            },
        },
        components: {
            Modal
        }
    }
</script>

<style lang="scss" scoped>
    .input-heigth {
        height: 38px;
    }
</style>



// WEBPACK FOOTER //
// SendInvoice.vue?37213b38